import type { filter } from '../Search/data'

export type LootBoxesType = {
  id: number | string
  title: string
  tagType: 'prime-orb' | 'car' | 'orb-item' | 'phone'
  price: number
  boxUrl: string
  boxColor1: string
  boxColor2: string
  bonus?: string
  quantity: number
  creatorAvatar: string
  creatorName: string
  openPrice: number
}

export const boxes: LootBoxesType[] = [
  {
    id: 1,
    title: '#9899',
    tagType: 'prime-orb',
    price: 1250.93,
    boxUrl: '/assets/lootboxes/loot-boxes-1.png',
    boxColor1: '#DBFE024D',
    boxColor2: '#DBFE0200',
    bonus: '4.5%·10% ·950·730K·x1.6',
    quantity: 24,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 25.09,
  },
  {
    id: 2,
    title: 'Lamborgini Huracán',
    tagType: 'car',
    price: 249850,
    boxUrl: '/assets/lootboxes/loot-boxes-2.png',
    boxColor1: '#2CEA6580',
    boxColor2: '#2CEA6500',
    quantity: 35,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 598.45,
  },
  {
    id: 3,
    title: '#11223',
    tagType: 'orb-item',
    price: 230.34,
    boxUrl: '/assets/lootboxes/loot-boxes-3.png',
    boxColor1: '#9B8DFF80',
    boxColor2: '#9B8DFF00',
    bonus: '4.5%·10% ·950·730K·x1.6',
    quantity: 24,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 8.99,
  },
  {
    id: 4,
    title: 'Galaxy S24 Ultra',
    tagType: 'phone',
    price: 1250.93,
    boxUrl: '/assets/lootboxes/loot-boxes-4.png',
    boxColor1: '#3C8AFF80',
    boxColor2: '#3C8AFF00',
    quantity: 13,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 30.12,
  },
  {
    id: 5,
    title: '#9899',
    tagType: 'prime-orb',
    price: 1250.93,
    boxUrl: '/assets/lootboxes/loot-boxes-5.png',
    boxColor1: '#DBFE024D',
    boxColor2: '#DBFE0200',
    bonus: '4.5%·10% ·950·730K·x1.6',
    quantity: 24,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 25.09,
  },
  {
    id: 6,
    title: 'Galaxy S24 Ultra',
    tagType: 'phone',
    price: 1250.93,
    boxUrl: '/assets/lootboxes/loot-boxes-6.png',
    boxColor1: '#3C8AFF80',
    boxColor2: '#3C8AFF00',
    quantity: 24,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 25.09,
  },

  {
    id: 7,
    title: '#9899',
    tagType: 'prime-orb',
    price: 1250.93,
    boxUrl: '/assets/lootboxes/loot-boxes-1.png',
    boxColor1: '#DBFE024D',
    boxColor2: '#DBFE0200',
    bonus: '4.5%·10% ·950·730K·x1.6',
    quantity: 24,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 25.09,
  },
  {
    id: 8,
    title: 'Lamborgini Huracán',
    tagType: 'car',
    price: 249850,
    boxUrl: '/assets/lootboxes/loot-boxes-2.png',
    boxColor1: '#2CEA6580',
    boxColor2: '#2CEA6500',
    quantity: 35,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 598.45,
  },
  {
    id: 9,
    title: '#11223',
    tagType: 'orb-item',
    price: 230.34,
    boxUrl: '/assets/lootboxes/loot-boxes-3.png',
    boxColor1: '#9B8DFF80',
    boxColor2: '#9B8DFF00',
    bonus: '4.5%·10% ·950·730K·x1.6',
    quantity: 24,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 8.99,
  },
  {
    id: 10,
    title: 'Galaxy S24 Ultra',
    tagType: 'phone',
    price: 1250.93,
    boxUrl: '/assets/lootboxes/loot-boxes-4.png',
    boxColor1: '#3C8AFF80',
    boxColor2: '#3C8AFF00',
    quantity: 13,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 30.12,
  },
  {
    id: 11,
    title: '#9899',
    tagType: 'prime-orb',
    price: 1250.93,
    boxUrl: '/assets/lootboxes/loot-boxes-5.png',
    boxColor1: '#DBFE024D',
    boxColor2: '#DBFE0200',
    bonus: '4.5%·10% ·950·730K·x1.6',
    quantity: 24,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 25.09,
  },
  {
    id: 12,
    title: 'Galaxy S24 Ultra',
    tagType: 'phone',
    price: 1250.93,
    boxUrl: '/assets/lootboxes/loot-boxes-6.png',
    boxColor1: '#3C8AFF80',
    boxColor2: '#3C8AFF00',
    quantity: 24,
    creatorAvatar: '/assets/lootboxes/prll.svg',
    creatorName: 'PrimeRoll',
    openPrice: 25.09,
  },
]

export const collections: filter[] = [
  {
    key: 'primeorb',
    value: 'PrimeOrb',
  },
  {
    key: 'car',
    value: 'Car',
  },
  {
    key: 'phone',
    value: 'Phone',
  },
  {
    key: 'prOrbItem',
    value: 'Pr-orb Item',
  },
]
